<template>
  <div class="custom-surveys-participation-wrapper">
    <div class="body">
      <div class="content">
        <PageLayout>
          <template slot="header">
            <div>
              <div class="d-flex m-3 mx-lg-0">
                <Breadcrumb :list="breadcrumbList" />
                <ExportData
                  id="exportData"
                  class="ml-sm-2 mt-2 mt-sm-0"
                  :canExport="$can('use', 'report.export')"
                  :hasXlsx="true"
                  :hasCsv="false"
                  @export="handleExportClick"
                />
                <Dropdown
                  v-if="false"
                  class="ml-md-3"
                  :data="groupOptions"
                  :selectedId="selectedGroupId"
                  :showSearch="true"
                  @selectItem="groupSelected"
                />
                <GroupsTreeSelect class="ml-md-1" @selectItem="groupSelected" />
              </div>
              <ReportsNavbar
                :canSeeSettings="summary.isOwner || isAdmin"
                :hasFeedbacks="summary.hasFeedbacks"
              />
              <b-card
                v-if="!isLoading"
                :class="{ 'inactive-group-card': selectedGroup.inactive }"
              >
                <header slot="header">
                  <b-row>
                    <b-col :title="labels.overall" md="10">
                      {{ labels.overall }}
                      <span v-if="selectedGroup.name">
                        - {{ selectedGroup.name }}
                      </span>
                    </b-col>
                  </b-row>
                </header>
                <h5>{{ summary.title }}</h5>
                <p>
                  {{
                    summary.description
                      ? summary.description
                      : labels.withoutDescription
                  }}
                </p>
              </b-card>
              <br v-if="!isLoading" />
            </div>
          </template>
          <template slot="main">
            <div v-if="isLoading" class="loading">
              <loading />
              <p>{{ reportsResources.loading }}</p>
            </div>
            <div class="page-reports" v-if="!isLoading">
              <b-row class="arrows ie-11-arrows">
                <span class="mdi mdi-arrow-right-bold-circle"></span>
                <span class="mdi mdi-arrow-right-bold-circle"></span>
              </b-row>
              <b-row :class="{ 'inactive-group-card': selectedGroup.inactive }">
                <b-col xl="4" class="mb-4">
                  <b-card class="text-center participation-card">
                    <header
                      slot="header"
                      class="text-left"
                      :title="labels.invitedPublic"
                    >
                      <span v-html="labels.invitedPublic" />
                      <GroupsInactive v-if="selectedGroup.inactive" />
                    </header>
                    <div class="invited-count mt-5" id="invitedCount">
                      {{ participation.invitedCount }}
                    </div>
                    <div class="invited-date">
                      {{ reportsResources.header.since }}
                      {{ participation.createdAt }}
                    </div>
                    <b-row class="arrows-mobile mt-2 pt-1">
                      <div class="white-square"></div>
                      <span class="mdi mdi-arrow-down-bold-circle"></span>
                    </b-row>
                  </b-card>
                </b-col>
                <b-col xl="4" class="mb-4">
                  <b-card class="text-center participation-card">
                    <header
                      slot="header"
                      class="text-left"
                      :title="labels.confirmedPublic"
                    >
                      <span v-html="labels.confirmedPublic" />
                      <GroupsInactive v-if="selectedGroup.inactive" />
                    </header>
                    <div
                      class="flex justify-content-center"
                      id="confirmedCount"
                    >
                      <OverView
                        :score="participation.confirmedCount"
                        :maxValue="participation.invitedCount"
                        :name="'confirmed'"
                      />
                    </div>
                    <b-row class="arrows-mobile">
                      <div class="white-square"></div>
                      <span class="mdi mdi-arrow-down-bold-circle"></span>
                    </b-row>
                  </b-card>
                </b-col>
                <b-col xl="4" class="mb-4">
                  <b-card class="text-center participation-card">
                    <header
                      slot="header"
                      class="text-left"
                      :title="labels.responderPublic"
                    >
                      <span v-html="labels.responderPublic" />
                      <GroupsInactive v-if="selectedGroup.inactive" />
                    </header>
                    <div class="flex justify-content-center" id="activeCount">
                      <OverView
                        :score="participation.activeCount"
                        :maxValue="
                          participation.invitedCount > 0 &&
                          participation.activeCount === 0 &&
                          participation.confirmedCount === 0
                            ? 1
                            : participation.confirmedCount
                        "
                        :name="'active'"
                      />
                    </div>
                  </b-card>
                </b-col>
              </b-row>
              <b-row :class="{ 'inactive-group-card': selectedGroup.inactive }">
                <b-col xl="4" class="mb-4">
                  <b-card class="live-summary">
                    <header slot="header">
                      <b-row>
                        <b-col :title="sectionTitles">
                          <h6>{{ reportsResources.overall.headerEngaje }}</h6>
                          <small>
                            {{
                              `${participation.activeCount}
                              ${reportsResources.overall.activeUsers} /
                              ${participation.invitedCount}
                              ${reportsResources.overall.invited}`
                            }}
                          </small>
                        </b-col>
                      </b-row>
                    </header>
                    <div class="flex">
                      <Overall :score="engajePercent" :isPercentage="true" />
                    </div>
                    <b-row>
                      <b-col class="m-2 pt-4">
                        <p>
                          {{
                            labels.tipEngaje
                              | parse({
                                INVITED: participation.invitedCount,
                                ACTIVE: participation.activeCount,
                                CYCLES: 2,
                              })
                          }}
                        </p>
                      </b-col>
                    </b-row>
                  </b-card>
                </b-col>
                <b-col class="mb-4">
                  <b-card class="live-summary">
                    <header slot="header">
                      <b-row>
                        <b-col :title="sectionTitles">
                          <h6>{{ reportsResources.overall.titleEngaje }}</h6>
                        </b-col>
                      </b-row>
                    </header>
                    <div>
                      <VueApexCharts
                        type="line"
                        :options="chartOptionsInvited"
                        :series="seriesInvited"
                      >
                      </VueApexCharts>
                    </div>
                  </b-card>
                </b-col>
              </b-row>
              <b-row :class="{ 'inactive-group-card': selectedGroup.inactive }">
                <b-col xl="4" class="mb-4">
                  <b-card class="live-summary">
                    <header slot="header">
                      <b-row>
                        <b-col :title="sectionTitles">
                          <h6>
                            {{ reportsResources.overall.headerResponders }}
                          </h6>
                          <small>
                            {{
                              `${participation.activeCount}
                              ${reportsResources.overall.activeUsers} /
                              ${participation.confirmedCount}
                              ${reportsResources.overall.confirmed}`
                            }}
                          </small>
                        </b-col>
                      </b-row>
                    </header>
                    <div class="flex">
                      <Overall
                        :score="
                          engajePercent >= 0
                            ? participation.participationRate / 10
                            : undefined
                        "
                        :isPercentage="true"
                      />
                    </div>
                    <b-row>
                      <b-col class="m-2 pt-4">
                        <p>
                          {{
                            labels.tipResponders
                              | parse({
                                CONFIRMED: participation.confirmedCount,
                                ACTIVE: participation.activeCount,
                                CYCLES: 2,
                              })
                          }}
                        </p>
                      </b-col>
                    </b-row>
                  </b-card>
                </b-col>
                <b-col class="mb-4">
                  <b-card class="live-summary">
                    <header slot="header">
                      <b-row>
                        <b-col :title="sectionTitles">
                          <h6>
                            {{ reportsResources.overall.titleResponders }}
                          </h6>
                        </b-col>
                      </b-row>
                    </header>
                    <div>
                      <VueApexCharts
                        type="line"
                        :options="chartOptionsConfirmed"
                        :series="seriesConfirmed"
                      >
                      </VueApexCharts>
                    </div>
                  </b-card>
                </b-col>
              </b-row>
            </div>
            <UnauthorizedModal ref="modal-unauthorized" />
          </template>
        </PageLayout>
      </div>
      <ReportsSidebar v-if="false" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { isAdmin } from '@/service/user'
import Dropdown from '@/components/Shared/Form/Dropdown.vue'
import Breadcrumb from '@/components/Shared/Breadcrumb.vue'
import PageLayout from '@/components/Home/PageLayout.vue'
import ReportsNavbar from '@/components/Home/CustomSurveys/ReportsNavbar.vue'
import ReportsSidebar from '@/components/Home/CustomSurveys/ReportsSidebar.vue'
import OverView from '@/components/Charts/OverView.vue'
import Overall from '@/components/CustomSurveys/Reports/Overall.vue'
import GroupsTreeSelect from '@/components/CustomSurveys/Reports/GroupsTreeSelect.vue'
import UnauthorizedModal from '@/components/CustomSurveys/Reports/UnauthorizedModal.vue'
import VueApexCharts from 'vue-apexcharts'
import ExportData from '@/components/Reports/ExportData.vue'
import GroupsInactive from '@/components/Groups/GroupsInactive.vue'
import Loading from '@/components/Shared/Loading.vue'

export default {
  components: {
    Dropdown,
    Breadcrumb,
    PageLayout,
    ReportsNavbar,
    ReportsSidebar,
    OverView,
    Overall,
    GroupsTreeSelect,
    UnauthorizedModal,
    VueApexCharts,
    ExportData,
    GroupsInactive,
    Loading,
  },
  data() {
    return {
      selectedGroup: {},
      isLoading: false,
    }
  },
  computed: {
    ...mapGetters({
      resources: 'resources',
      selectedGroupId: 'customSurveyResults/selectedGroupId',
      groups: 'customSurveyResults/groups',
      summary: 'customSurveyResults/summary',
      participation: 'customSurveyResults/participation',
    }),
    labels: function() {
      return {
        ...this.resources.page.home.customSurveys.participation,
        ...this.resources.page.home.customSurveys.report,
      }
    },
    reportsResources() {
      return this.resources.page.reports.participation
    },
    sectionTitles() {
      return this.reportsResources.title
    },
    breadcrumbList() {
      return [
        {
          label: this.resources.page.home.customSurveys.title,
          link: { name: 'custom-surveys' },
        },
      ]
    },
    chartOptionsConfirmed() {
      const arr = [...this.participation.history.confirmedResponders].sort()
      return this.getChartOptions({ min: arr[0], max: arr[arr.length - 1] })
    },
    chartOptionsInvited() {
      const arr = [...this.participation.history.totalResponders].sort()
      return this.getChartOptions({ min: arr[0], max: arr[arr.length - 1] })
    },
    seriesConfirmed() {
      return [
        {
          name: this.reportsResources.overall.participation,
          data: this.participation.history.confirmedResponders,
        },
      ]
    },
    seriesInvited() {
      return [
        {
          name: this.reportsResources.overall.participation,
          data: this.participation.history.totalResponders,
        },
      ]
    },
    engajePercent() {
      return (
        (this.participation.activeCount * 10) / this.participation.invitedCount
      )
    },
    customSurveyId: function() {
      return this.$route.params.id
    },
    isAdmin() {
      return isAdmin()
    },
    groupOptions() {
      return {
        groups: [
          {
            _id: 'consolidate',
            name: this.resources.page.home.customSurveys.consolidate,
            isConsolidate: true,
          },
          ...this.groups,
        ],
      }
    },
  },
  methods: {
    handleExportClick() {
      // eslint-disable-next-line no-undef
      const env = window.env || process.env

      window.open(
        `${env.VUE_APP_EXPORTER_API_HOST}/custom-surveys/${this.customSurveyId}/participation/${this.selectedGroup._id}/xlsx?token=${localStorage.jwt}&language=${localStorage.languageabrev}`,
        '_blank'
      )
    },
    async groupSelected(group) {
      this.selectedGroup = this.groupOptions.groups.find(
        g => g._id === group._id
      )

      const groupId = group._id

      this.isLoading = true
      try {
        await this.$store.dispatch('customSurveyResults/loadParticipation', {
          customSurveyId: this.customSurveyId,
          groupId,
        })
      } catch (error) {
        const { status } = error.response
        if (status === 401) {
          this.$refs['modal-unauthorized'].show()
        }
      }
      this.isLoading = false
    },
    getChartOptions({ min, max }) {
      const colorStops = this.getColorStops({ min, max })
      return {
        stroke: {
          width: 2,
          curve: 'smooth',
          lineCap: 'round',
        },
        xaxis: {
          type: 'datetime',
          categories: this.participation.history.dates,
          labels: {
            format: 'dd/MM/yyyy',
            style: {
              fontSize: '10px',
            },
          },
        },
        fill: {
          type: 'gradient',
          gradient: {
            shade: 'dark',
            shadeIntensity: 1,
            type: 'vertical',
            colorStops,
          },
        },
        tooltip: {
          marker: {
            show: false,
          },
          x: {
            format: 'dd/MM/yyyy',
          },
        },
        responsive: [
          {
            breakpoint: 400,
            options: {
              chart: {
                type: 'area',
              },
            },
          },
        ],
      }
    },
    getColorStops({ min, max }) {
      const colorStops = []

      if (max < 50) {
        colorStops.push({
          offset: 0,
          color: '#eb235e', // red
          opacity: 1,
        })
        return colorStops
      } else if (max < 75) {
        colorStops.push({
          offset: 0,
          color: '#eda008', // yellow
          opacity: 1,
        })
        if (min < 50) {
          const offset = (100 * (max - 50)) / (max - min)
          colorStops.push({
            offset,
            color: '#eb235e', // red
            opacity: 1,
          })
        }
        return colorStops
      } else if (max >= 75) {
        colorStops.push({
          offset: 0,
          color: '#23ebb0', // green
          opacity: 1,
        })
        if (min < 75) {
          const offset = (100 * (max - 75)) / (max - min)
          colorStops.push({
            offset,
            color: '#eda008', // yellow
            opacity: 1,
          })
          if (min < 50) {
            const offset = (100 * (max - 50)) / (max - min)
            colorStops.push({
              offset,
              color: '#eb235e', // red
              opacity: 1,
            })
          }
        }
      }
      return colorStops
    },
  },
  async created() {
    const selectedGroupId = this.selectedGroupId
      ? this.selectedGroupId
      : 'consolidate'

    const requests = []
    requests.push(
      this.$store.dispatch('customSurveyResults/loadSummary', {
        customSurveyId: this.customSurveyId,
      })
    )
    requests.push(
      this.$store.dispatch('customSurveyResults/loadGroups', {
        customSurveyId: this.customSurveyId,
      })
    )
    requests.push(
      this.$store.dispatch('customSurveyResults/loadParticipation', {
        customSurveyId: this.customSurveyId,
        groupId: selectedGroupId,
      })
    )
    this.isLoading = true
    try {
      await Promise.all(requests)
      this.selectedGroup = this.groupOptions.groups.find(
        g => g._id === selectedGroupId
      )
    } catch (error) {
      const { status } = error.response
      if (status === 401) {
        this.$refs['modal-unauthorized'].show()
      }
    }
    this.isLoading = false
  },
  mounted: function() {
    this.$root.$emit('setPageTitle', {
      context: this,
      path: 'custom-survey/participation',
    })
  },
}
</script>

<style scoped lang="scss">
@import '~@/styles/custom/colors';

.custom-surveys-participation-wrapper {
  display: flex;
  flex-direction: column;
  min-height: 100%;
  width: 100%;

  .body {
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 100%;
    overflow: hidden;

    .content {
      padding: 0;
      position: relative;
      z-index: 0;
      min-width: 0px;
      flex: 1 1 auto;
      overflow: auto;
      flex-grow: 1;
      --webkit-flex-grow: 1;

      header {
        .d-flex {
          align-items: center;
          justify-content: space-between;
          flex-wrap: wrap;
        }
      }

      // participation
      _:-ms-fullscreen,
      :root .ie-11-arrows {
        justify-content: space-around;
        margin: 0px 145px 0px 145px;
      }

      header {
        .d-flex {
          align-items: center;
          justify-content: space-between;
          flex-wrap: wrap;
        }
      }

      .row {
        @media (max-width: 1199px) {
          margin-right: 0px;
          margin-left: 0px;
        }
      }

      .arrows {
        @media (max-width: 1199px) {
          z-index: -1;
          opacity: 0;
        }

        justify-content: space-evenly;
        margin: 0px 20px 0px 20px;
        position: relative;
        top: 170px;
        z-index: 1;

        .mdi-arrow-right-bold-circle {
          color: map-get($theme-colors, 'gray01');
          font-size: 70px;
        }
      }

      .arrows-mobile {
        .white-square {
          z-index: -1;
          background: white;
          position: absolute;
          height: 36px;
          width: 36px;
          top: 37px;
        }

        @media (max-width: 1199px) {
          z-index: 1;
          opacity: 1;
        }

        @media (min-width: 426px) {
          top: -14px;
        }

        justify-content: center;
        position: relative;
        top: 7px;
        z-index: -1;
        opacity: 0;

        .mdi-arrow-down-bold-circle {
          color: map-get($theme-colors, 'gray01');
          font-size: 70px;
        }
      }

      .participation-card {
        .card-body {
          height: 240px;

          .btn-lg {
            width: 200px;
            height: 42px;

            &.btn-overview {
              margin-top: -40px;
            }
          }

          .invited-count {
            text-align: center;
            font-size: 65px;
          }

          .invited-date {
            text-align: center;
            font-size: 14px;
            font-weight: 500;
            color: map-get($theme-colors, 'gray02');
          }
        }
      }

      .metrics-container .subTitle {
        color: map-get($theme-colors, 'gray02');
        font-size: 12px;
        text-decoration: none;
        margin: 0;
      }

      .empty-state-box {
        overflow: hidden;
        padding: 15px;
        display: flex;
        flex-direction: column;
        align-items: center;
        max-height: calc(100vh - 350px);
        text-align: center;
        width: 100%;

        video {
          text-align: center;
          min-height: 130px;
          max-height: 500px;
          max-width: 100%;
        }

        label {
          color: map-get($theme-colors, 'gray03');
          font-size: xx-large;
          @media (max-width: 991.98px) {
            font-size: large;
          }
        }
      }

      .page-reports {
        margin-bottom: 40px;
        margin-top: -107px;
      }

      .nav.header .nav-link {
        margin: 0rem !important;
      }

      .card {
        border-radius: 10px !important;
        .card-header {
          border-top-left-radius: 10px !important;
          border-top-right-radius: 10px !important;
          font-size: 24px;
        }
        @media (max-width: 575.98px) {
          // sm
          .card-body {
            padding: 0px 0px 10px 0px;
            margin: 0px;
          }
        }

        .flex {
          display: flex;
          justify-content: center;

          @media (max-width: 767px) {
            justify-content: center;
          }
        }
      }

      .loading {
        margin: 0 auto;
        text-align: center;
      }

      .admin {
        .card-body {
          height: 290px;
        }
      }

      .live-summary {
        height: 100%;
      }

      small {
        font-size: 75%;
      }

      .inactive-group-card {
        .card,
        .card-header {
          background: map-get($theme-colors, 'gray08') !important;
        }
      }
    }
  }
}
</style>
